// Lightweight renderer for article bodies.
// Rules (line-by-line): "## " = subheading, "- " = list item,
// blank line = paragraph break. Robust to headings immediately
// followed by bullet lists (no blank line required).
export default function MarkdownLite({ text }) {
  if (!text) return null;

  const out = [];
  let para = [];
  let list = [];
  let key = 0;

  const flushPara = () => {
    if (para.length) {
      out.push(
        <p key={key++} className="my-5 text-[#94A3B8] leading-relaxed text-lg">
          {para.join(" ")}
        </p>
      );
      para = [];
    }
  };
  const flushList = () => {
    if (list.length) {
      const items = list.slice();
      out.push(
        <ul key={key++} className="my-5 space-y-3 pl-1">
          {items.map((li, j) => (
            <li key={j} className="flex items-start gap-3 text-[#94A3B8] leading-relaxed">
              <span className="mt-2 h-1.5 w-1.5 shrink-0 bg-cyan-precision" />
              <span>{li}</span>
            </li>
          ))}
        </ul>
      );
      list = [];
    }
  };

  text.split("\n").forEach((raw) => {
    const line = raw.trim();
    if (line === "") {
      flushList();
      flushPara();
      return;
    }
    if (line.startsWith("## ")) {
      flushList();
      flushPara();
      out.push(
        <h2 key={key++} className="mt-12 mb-4 font-display text-2xl font-light tracking-tight text-[#F0F4F8]">
          {line.slice(3)}
        </h2>
      );
      return;
    }
    if (line.startsWith("- ")) {
      flushPara();
      list.push(line.slice(2));
      return;
    }
    flushList();
    para.push(line);
  });

  flushList();
  flushPara();

  return <div>{out}</div>;
}
